export default {
  defaultStyle:  data => ({
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    backgroundColor: '#fff',
    overflow: 'auto',
    datepicker: {
      position: 'relative',
      [`@media (min-width: ${data.modalBreak}px)`]: {
        position:'static'
      }
    },

    buttonContainer: data => ({
      [`@media (min-width: ${data.modalBreak}px)`]: {
        left: '15px',
      },
      cursor: 'pointer',
      display: 'block',
      position: 'absolute',
      top: 0,
      left: '35px',
      bottom: 0,
      width: '36px',
      color: 'transparent',
      '&:lang(ar)': {
        left: 'auto',
        right: '35px'
      }
    }),
    [`@media (min-width: ${data.modalBreak}px)`]: {
      padding: '0 35px',
      position: 'relative',
      minHeight:'365px'
    },
    '&:not($portalDesign)':{
      '& $datepickerRelative':{
      '@media (min-width: 951px)': {
          overflow: 'hidden',
          maxWidth: '780px',
          margin: '0 auto',
          padding: '0 70px',
          minHeight: '290px',
          boxSizing: ['content-box', '!important']
        }
      }
    },
  }),
  datepicker: data => ({
    position: 'relative',
    [`@media (min-width: ${data.modalBreak}px)`]: {
      position:'static'
    }
  }),
  datepickerRelative: data => ({
    backgroundColor: '#fff',
    textAlign: 'center',
    [`@media (min-width: ${data.modalBreak}px)`]: {
      padding: '0 40px',
      maxWidth: '780px',
      margin: '0 auto',
    },
  }),
  monthContQuotaService:{},
  datepickerMonthContainer: data => ({
    [`@media (min-width: ${data.modalBreak}px)`]: {
      display:'flex',
      alignItems:'flex-start',
      justifyContent:'space-between',
    },
    '&:lang(ar)': {
      direction: 'rtl',
    },
    '&$monthContQuotaService':{
      marginBottom: '20px',
    }
  }),
  buttonContainer: data => ({
    display: 'block',
    position: 'absolute',
    top: 0,
    left: '35px',
    bottom: 0,
    width: '36px',
    color: 'transparent',
    '&:lang(ar)': {
      left: 'auto',
      right: '35px'
    },
    [`@media (max-width: ${data.modalBreak - 1}px)`]: {
      top: '40px',
      left: '10px',
      width: '5px',
    }
  }),
  buttonCalendar: data => ({
    backgroundColor: data.mainColor,
    fontSize: '11px',
    lineHeight: '30px',
    position: 'absolute',
    top: '50%',
    left: 0,
    marginTop: '-7px',
    height: '30px',
    width: '30px',
    color: '#fff',
    transition: '.3s',
    borderRadius: '50%',
    cursor: 'initial',
    [`@media (min-width: ${data.modalBreak}px)`]: {
      height: '36px',
      width: '36px',
      cursor: 'pointer',
    },
    '&:lang(ar)': {
      left: 'auto',
      right: 0,
      transform: 'rotate(180deg)'
    }
  }),
  buttonRight: {
    left: 'auto',
    right: '35px',
    '&:lang(ar)': {
      left: '35px',
      right: 'auto'
    },
  },
  disabledButton: {
    backgroundColor: '#b2b2b2'
  },
  monthly: data => ({
    monthWrapper: {
      height: '350px',
      [`@media (min-width: ${data.modalBreak}px)`]: {
        width: 'calc(50% - 15px)',
        height: 'auto',
      },
      [`@media (min-width: ${data.modalBreak}px)`]: {
        float: 'left',
        '&:last-child': {
          marginLeft: '50px'
        }
      },
      '&:lang(ar)': {
        [`@media (min-width: ${data.modalBreak}px)`]: {
          float: 'right'
        },
        '&:last-child': {
          [`@media (min-width: ${data.modalBreak}px)`]: {
            marginLeft: '0',
            marginRight: '50px'
          }
        }
      },
    },
    monthTitle: {
      display: 'block',
      padding: '5px',
      backgroundColor: '#f6f6f6',
      borderBottom: '1px solid #e1e1e1',
      color: '#000',
      font: '300 20px/1.2 Roboto, sans-serif',
      top: 0,
      position: 'sticky',
      zIndex: 2,
      [`@media (min-width: ${data.modalBreak}px)`]: {
        position: 'relative',
        background: '0 0',
        fontSize: '16px',
        fontWeight: '500',
        lineHeight: '1.25',
        padding: '13px 5px'
      },
    },
    month: {
      color: 'black',
      textAlign: 'left',
      maxWidth: '300px',
      margin: '5px auto 5px',
      padding: '0 5px',
      [`@media (min-width: ${data.modalBreak}px)`]: {
        maxWidth: 'none'
      },
      '@media (max-width: 420px)': {
        maxWidth: '280px',
      },
      '@media (max-width: 380px)': {
        maxWidth: '240px',
      },
      '&:lang(ar)': {
        textAlign: 'right'
      }
    },
    dayList: {
      margin: '0 auto',
      maxWidth: '280px',
      width: '100%',
      display: 'table',
      [`@media (min-width: ${data.modalBreak}px)`]: {
        maxWidth: 'none'
      },
      '@media (max-width: 420px)': {
        maxWidth: '280px',
      },
      '@media (max-width: 380px)': {
        maxWidth: '240px',
      },
      borderBottom: '1px solid #e1e1e1',
    },
    weekDays: {
      width: '14.28%',
      textTransform: 'uppercase',
      font: '500 12px Roboto, sans-serif',
      padding: '12px 5px 10px',
      display: 'table-cell',
      color: '#000',
      [`@media (min-width: ${data.modalBreak}px)`]: {
        padding: '12px 5px 10px'
      }
    },
    portalDesign:{
      [`@media (min-width: ${data.modalBreak}px)`]: {
        width:'calc( 50% - 26px)',
        maxWidth:'390px',
      }
    },
  }),
  day: {
    quotaServiceDay:{},
    day: {
      display: 'inline-block',
      verticalAlign: 'top',
      position: 'relative',
      padding: '6px 2px',
      width: '14.2857%',
      boxSizing: 'border-box',
      textAlign: 'center',
      cursor: 'pointer',
      minHeight: '45px',
      background: 'none',
      font: '15px/15px Roboto, sans-serif',
      color:'#000',
      margin:'0.5px 0',
      fontWeight: '500',

      '&$quotaServiceDay':{
        '& > span': {
          height: 'unset',
        },
      },

      '&:hover': {
        '@media (min-width: 801px)': {
          backgroundColor: data => `${data.mainColor}1A`,
        }
      }
    },
    daySelected: {
      '&:hover': {
        backgroundColor: data => data.mainColor,
      }
    },
    today: {
      color: data => data.mainColor,
    },
    isSelected: {
      backgroundColor: data => data.mainColor,
      color: '#fff',
      ' & span':{
        color: '#fff !important',
      },
      '&$quotaServiceDay':{
        backgroundColor: data => `${data.calendarColor}8A`,
        ' & span':{
          color: '#000 !important',
        },
      }
    },
    inRange: {
      backgroundColor: data => `${data.mainColor}1A`,
    },
    preSelected: {
      '@media (min-width: 801px)': {
        '&:hover': {
          background: data => `${data.calendarColor}1A`,
        },
      },
      '&:focus': {
        background: data => `${data.calendarColor}8A`,
      }
    },
    disabled: {
      color: '#bbbbbb',
      pointerEvents: 'none',
    },
    startRange: {
      '&:before': {
        borderLeftColor: data => data.mainColor,
        content: `''`,
        position: 'absolute',
        left: '100%',
        top: '50%',
        borderLeftWidth: '5px',
        borderLeftStyle: 'solid',
        marginTop: '-23px',
        zIndex: 1
      },
      '&:lang(ar)': {
        '&:before': {
          left: 'auto',
          right: '100%',
          borderRightColor: data => data.mainColor,
          borderRightWidth: '5px',
          borderRightStyle: 'solid',
          borderLeft: 'none'
        }
      }
    },
    moreSpecEndRage:{},
    endRange: {
      composes: '$startRange',
      '&$moreSpecEndRage:before': {
        composes: '$startRange',
        borderRightColor: data => data.mainColor,
        left: 'auto',
        right: '100%',
        borderLeft: 0,
        borderRightStyle: 'solid',
        borderRightWidth: '5px'
      },
      '&:lang(ar)': {
        '&$moreSpecEndRage:before': {
          left: '100%',
          right: 'auto',
          borderRight: 'none',
          borderLeftColor: data => data.mainColor,
          borderLeftWidth: '5px',
          borderLeftStyle: 'solid'
        }
      }
    },
    isSingle: {
    },
    currentDate: data => ({
      '&:after': {
        content: `''`,
        position: 'absolute',
        left: '50%',
        bottom: '2px',
        width: '6px',
        height: '6px',
        marginLeft: '-3px',
        borderRadius: '50%'
      },
      [`@media (min-width: ${data.modalBreak}px)`]: {
        '&:after': {
          bottom: 0
        }
      },
      '&:lang(ar)': {
        '&:after': {
          left: 'auto',
          right: '50%',
          marginLeft: '0',
          marginRight: '-3px'
        }
      }
    }),
  },
  noAvailRoomDetailDatepicker:{
    composes:'$noAvailAlertDatepicker'
  },
  mobileArrows: {
    overflow: 'hidden !important',
  },
  noDispoModal:{
    position:'static'
  },
  noAvailAlertDatepicker: data => ({
    position:'relative',
    maxHeight: '800px',
    overflow:'scroll',
    zIndex:'5',
    borderTop:'1px solid #d8d8d8',
    borderBottom:'1px solid #d8d8d8',
    [`@media (min-width: ${data.modalBreak}px)`]: {
      height:'100%',
      borderTop:'none',
      borderBottom:'none',
      overflow:'auto',
      minHeight: '365px',
    },
  }),
  portalDesign:{
    boxShadow:'none',
  },
  hideDatepicker:{
    display:'none'
  },
  roundedTheme:{
    borderRadius: '25px',
    scrollbarWidth: 'none',
  }
};
